import { ReactComponent as OpynNamirial } from 'src/images/icons/logo_opyn_namirial.svg';
import { ReactComponent as OpynStripe } from 'src/images/icons/logo_opyn_stripe.svg';
import { Flex } from 'src/style/flexbox.style';
import AlertCard, { AlertCardProp } from './AlertCard.component';
import { StyleSheetManager } from 'styled-components';
import { shouldForwardProp } from 'src/style-utils/functions';

function AlertCardsContainer({ isIta }: { isIta: boolean }) {
  const cards: Array<AlertCardProp> = [
    {
      icon: isIta ? OpynNamirial : undefined,
      title: 'text.cardNamirialTitle',
      content: isIta
        ? 'text.cardNamirialContent'
        : 'text.cardNamirialContentExt',
    },
    {
      icon: OpynStripe,
      title: 'text.cardStripeTitle',
      content: 'text.cardStripeContent',
    },
  ];
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <Flex flexWrap="wrap" gap="2rem">
        {cards.map((card, i) => (
          <AlertCard {...card} key={i} />
        ))}
      </Flex>
    </StyleSheetManager>
  );
}

export default AlertCardsContainer;
